export default __webpack_public_path__ + "static/media/gallery-1.ae1dfe39.jpg";